import React from "react"
import { Leaf } from "lucide-react"
import { useStats } from "../hooks/useStats"

interface HeroSectionProps {
  onScrollToForm: () => void
}

export const HeroSection: React.FC<HeroSectionProps> = ({ onScrollToForm }) => {
  const { stats, loading } = useStats()

  return (
    <div>
    <div className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/20 rounded-full px-4 py-1.5 mb-6">
      <Leaf className="w-3.5 h-3.5 text-emerald-400" />
      <span className="text-emerald-400 text-xs font-semibold tracking-wide">
        National Tree Inventory Programme
      </span>
    </div>

    <h1 className="text-5xl lg:text-6xl font-black text-white leading-[1.05] mb-6 tracking-tight">
      Register your<br />
      <span className="text-emerald-400">farm trees</span><br />
      today.
    </h1>

    <p className="text-neutral-400 text-lg leading-relaxed mb-8 max-w-md">
      Join thousands of Tanzanian farmers contributing to the national
      tree inventory. Your farm data helps build a greener future.
    </p>

    <div className="flex gap-3 flex-wrap">
      <button
        onClick={onScrollToForm}
        className="px-6 py-3 bg-emerald-500 hover:bg-emerald-400 text-black font-bold text-sm rounded-xl transition-all hover:scale-105 active:scale-95"
      >
        Register Now — It's Free
      </button>
      
      <a
        href="#how-it-works"
        className="px-6 py-3 border border-neutral-600 hover:border-neutral-400 text-neutral-300 hover:text-white font-medium text-sm rounded-xl transition-all"
      >
        How it works
      </a>
    </div>

    <div className="flex gap-8 mt-12 pt-8 border-t border-white/10">
      {loading ? (
        <>
          <div key="farmers">
            <div className="text-2xl font-black text-white">Loading...</div>
            <div className="text-xs text-neutral-500 mt-0.5">Farmers</div>
          </div>
          <div key="trees">
            <div className="text-2xl font-black text-white">Loading...</div>
            <div className="text-xs text-neutral-500 mt-0.5">Trees</div>
          </div>
          <div key="regions">
            <div className="text-2xl font-black text-white">Loading...</div>
            <div className="text-xs text-neutral-500 mt-0.5">Regions</div>
          </div>
        </>
      ) : (
        <>
          <div key="farmers">
            <div className="text-2xl font-black text-white">{stats.total_farmers.toLocaleString()}+</div>
            <div className="text-xs text-neutral-500 mt-0.5">Farmers</div>
          </div>
          <div key="trees">
            <div className="text-2xl font-black text-white">{stats.total_trees.toLocaleString()}+</div>
            <div className="text-xs text-neutral-500 mt-0.5">Trees</div>
          </div>
          <div key="regions">
            <div className="text-2xl font-black text-white">{stats.active_regions}</div>
            <div className="text-xs text-neutral-500 mt-0.5">Regions</div>
          </div>
        </>
      )}
    </div>
  </div>
)
}